import React from "react";
import Slider from "react-slick";
import img1 from "../../images/1.svg";
import img2 from "../../images/2.svg";
import img3 from "../../images/3.svg";
import img4 from "../../images/4.svg";

function Carousel() {
	return <></>;
}

export default Carousel;
